import { type A7FIAIssuer, getIssuersColumns } from "./columns";
import { filterA7FIAIssuersSchema, FilterA7FIAIssuers } from "./filter";
import { Table } from "@/pages/a7/Table";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

const table_name = "a7_fia_issuers";

export const A7FIAIssuersTable = () => {
  const { t, i18n } = useTranslation(["tables"]);
  const columnVisibilityInit = {
    contact_fonds: false,
    contact_afd: false,
    business_manager: false,
  };
  const columns = useMemo(() => getIssuersColumns(t), [t, i18n.language]);

  return (
    <Table<A7FIAIssuer, typeof filterA7FIAIssuersSchema>
      label={t(`${table_name}.title`, { defaultValue: "Issuers" })}
      client="a7"
      table_name={table_name}
      columns={columns}
      filter={<FilterA7FIAIssuers />}
      columnVisibilityInit={columnVisibilityInit}
    />
  );
};
